declare namespace $ {

	export class $mol_icon_chart_timeline extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=timeline.view.tree.d.ts.map